export default 
[
    {
        "name": "Triangle count reduction",
        "enforce": [],
        "operations":
        [
            {
                "name": "Remove occluded geometries",
                "id": "remove occluded geometries",
                "params": 
                [
                    {
                        "name": "Level",
                        "id": "level",
                        "type": "dropdown",
                        "options": ["Parts", "Patches", "Polygons"],
                        "default": "Parts"
                    },
                    {
                        "name": "Resolution",
                        "id": "resolution",
                        "type": "dropdown",
                        "options": ["low", "medium", "high"],
                        "default": "low"
                    },
                    {
                        "name": "Sphere count",
                        "id": "sphereCount",
                        "type": "number",
                        "default": 256
                    },
                    {
                        "name": "fovX",
                        "id": "fovX",
                        "type": "number",
                        "default": 60
                    },
                    {
                        "name": "Consider Transparent Opaque",
                        "id": "considerTransparentOpaque",
                        "type": "boolean",
                        "default": false
                    },
                    {
                        "name": "Adjacency Depth",
                        "id": "adjacencyDepth",
                        "type": "dropdown",
                        "options": ["None", "Adjacent polygons", "Adjacent polygons and their adjacent polygons"],
                        "default": "None"
                    }
                ]
            },
            {
                "name": "Decimate to quality",
                "id": "decimate to quality",
                "params": 
                [
                    {
                        "name": "Level",
                        "id": "level",
                        "type": "dropdown",
                        "options": ["low", "medium", "high"],
                        "default": "medium"
                    }
                ]
            },
            {
                "name": "Decimate to target (total count)",
                "id": "decimate to target",
                "params": 
                [
                    {
                        "name": "Target count",
                        "id": "target",
                        "type": "number",
                        "default": 100000
                    }
                ]
            },
            {
                "name": "Decimate to target (% of original count)",
                "id": "decimate to %",
                "params": 
                [
                    {
                        "name": "Target percentage",
                        "id": "target",
                        "type": "number",
                        "default": 0.1
                    }
                ]
            },
            {
                "name": "Re-Tessellate",
                "id": "tesselate",
                "params": 
                [
                    {
                        "name": "Level",
                        "id": "level",
                        "type": "dropdown",
                        "options": ["low", "medium", "high"],
                        "default": "medium"
                    }
                ]
            },
            {
                "name": "Tessellate with custom max sag",
                "id": "tesselate with custom max sag",
                "params": 
                [
                    {
                        "name": "Max sag",
                        "id": "maxSag",
                        "type": "number",
                        "default": 0.1
                    }
                ]
            },
            {
                "name": "Remove holes",
                "id": "remove holes",
                "params": 
                [
                    {
                        "name": "Max Diameter",
                        "id": "maxDiameter",
                        "type": "number",
                        "default": -1
                    }
                ]
            },
        ]
    },
    {
        "name": "Object editing",
        "enforce": [],
        "operations":
        [
            {
                "name": "Move Pivot Point To Occurence Center",
                "id": "movePivotPointToOccurenceCenter",
                "params": [
                    {
                        "name": "Apply to children",
                        "id": "applyToChildren",
                        "type": "bool",
                        "default": false
                    },
                ]
            },
            {
                "name": "Reset transform",
                "id": "reset transform",
                "params": []
            },
            {
                "name": "Explode connected meshes",
                "id": "explode connected meshes",
                "params": []
            },
            {
                "name": "Merge identical materials",
                "id": "merge identical materials",
                "params": []
            },
            {
                "name": "Remove materials",
                "id": "remove materials",
                "params": []
            },
            {
                "name": "Remove UV",
                "id": "remove uv",
                "params": []
            },
            {
                "name": "Automatic UV mapping",
                "id": "automatic uv mapping",
                "params": []
            },
            {
                "name": "Invert faces orientation",
                "id": "invert faces orientation",
                "params": []
            },
            {
                "name": "Create instances by similarity",
                "id": "create instances by similarity",
                "params": 
                [
                    {
                        "name": "Dimensions",
                        "id": "dimensions",
                        "type": "number",
                        "default": 0.98
                    },
                    {
                        "name": "Polycount",
                        "id": "polycount",
                        "type": "number",
                        "default": 0.98
                    }
                ]
            },
        ]
    },
    {
        "name": "Object count reduction",
        "enforce": [ "ONE_OPERATION_PER_REVISION" ],
        "operations":
        [
            {
                "name": "Merge nodes at final hierarchy level",
                "id": "merge at final level",
                "params": 
                [
                    {
                        "name": "Collapse to parent",
                        "id": "collapse",
                        "type": "boolean",
                        "default": false
                    }
                ]
            },
            {
                "name": "Merge nodes at hierarchy level",
                "id": "merge at tree level",
                "params": 
                [
                    {
                        "name": "Level",
                        "id": "level",
                        "type": "number",
                        "default": 4
                    }
                ]
            },
            {
                "name": "Merge nodes with shared materials",
                "id": "merge by materials",
                "params": []
            },
            {
                "name": "Delete empty occurrences",
                "id": "delete empty",
                "params": []
            },
            {
                "name": "Merge parts",
                "id": "merge parts",
                "params": []
            },
            {
                "name": "Delete occurrences",
                "id": "delete occurrences",
                "params": []
            },
            {
                "name": "Rename parts and compress tree",
                "id": "rename parts with parent name and compress tree",
                "params": []
            }
        ]
    }
];